import { render } from "./AccessJoin.vue?vue&type=template&id=a2be5926&scoped=true"
import script from "./AccessJoin.vue?vue&type=script&lang=js"
export * from "./AccessJoin.vue?vue&type=script&lang=js"

import "./AccessJoin.vue?vue&type=style&index=0&id=a2be5926&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2be5926"]])

export default __exports__